// extracted by mini-css-extract-plugin
export default {"SearchModel":"search-mobile_SearchModel__Ogyj4"};